const currentYear = new Date().getFullYear();

export const COUNT_OPTIONS = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10+"].map((v) => ({
  label: v,
  value: v,
}));

export const YEAR_OPTIONS = Array.from({ length: 20 }, (_, i) => {
  const year = String(currentYear - i);
  return { label: year, value: year };
});

export const YES_NO_OPTIONS = [
  { label: "Yes", value: "YES" },
  { label: "No", value: "NO" },
];

export const YES_NO_NOT_AVAILABLE_OPTIONS = [
  { label: "Yes", value: "YES" },
  { label: "No", value: "NO" },
  { label: "Not available", value: "NOT_AVAILABLE" },
];

export const YES_NO_PATIENT_DECLINED_OPTIONS = [
  { label: "Yes", value: "YES" },
  { label: "No", value: "NO" },
  { label: "Patient Declined", value: "PATIENT_DECLINED" },
];

export const YES_NO_DECLINED_OPTIONS = [
  { label: "Yes", value: "YES" },
  { label: "No", value: "NO" },
  { label: "Declined", value: "DECLINED" },
];

export const YES_NO_DECLINED_NOT_AVAILABLE_OPTIONS = [
  { label: "Yes", value: "YES" },
  { label: "No", value: "NO" },
  { label: "Declined", value: "DECLINED" },
  { label: "Not available", value: "NOT_AVAILABLE" },
];

export const COPD_DYSPNOEA_OPTIONS = [
  { label: "Grade 0 – Not troubled by breathlessness except on strenuous exercise", value: "0" },
  { label: "Grade 1 – Short of breath when hurrying on the level or up a slight hill", value: "1" },
  { label: "Grade 2 – Walks slower than people of same age on the level or has to stop for breath when walking at own pace", value: "2" },
  { label: "Grade 3 – Stops for breath after walking 100 yards (91m) or after a few minutes on the level", value: "3" },
  { label: "Grade 4 – Too breathless to leave the house, or breathless when dressing or undressing", value: "4" },
];

export const FOOT_AND_LIMB_REVIEW_OPTIONS = [
  { label: "Posterior Tibial Present", value: "POSTERIOR_TIBIAL_PRESENT" },
  { label: "Posterior Tibial Absent", value: "POSTERIOR_TIBIAL_ABSENT" },
  { label: "Dorsalis Pedis Present", value: "DORSALIS_PEDIS_PRESENT" },
  { label: "Dorsalis Pedis Absent", value: "DORSALIS_PEDIS_ABSENT" },
  { label: "Vibration Sense Normal", value: "VIBRATION_SENSE_NORMAL" },
  { label: "Vibration Sense Abnormal", value: "VIBRATION_SENSE_ABNORMAL" },
  { label: "Monofilament Test Normal", value: "MONOFILAMENT_TEST_NORMAL" },
  { label: "Monofilament Test Abnormal", value: "MONOFILAMENT_TEST_ABNORMAL" },
  { label: "Foot Ulceration Present", value: "FOOT_ULCERATION_PRESENT" },
  { label: "Foot Ulceration Absent", value: "FOOT_ULCERATION_ABSENT" },
  { label: "Foot Deformity Present", value: "FOOT_DEFORMITY_PRESENT" },
  { label: "Foot Deformity Absent", value: "FOOT_DEFORMITY_ABSENT" },
];

export const FOOT_AND_LIMB_REVIEW_PAIRS = [
  { label: "Posterior Tibial", values: ["POSTERIOR_TIBIAL_PRESENT", "POSTERIOR_TIBIAL_ABSENT"], optionLabels: ["Present", "Absent"] },
  { label: "Dorsalis Pedis", values: ["DORSALIS_PEDIS_PRESENT", "DORSALIS_PEDIS_ABSENT"], optionLabels: ["Present", "Absent"] },
  { label: "Vibration Sense", values: ["VIBRATION_SENSE_NORMAL", "VIBRATION_SENSE_ABNORMAL"], optionLabels: ["Normal", "Abnormal"] },
  { label: "10g Monofilament Test", values: ["MONOFILAMENT_TEST_NORMAL", "MONOFILAMENT_TEST_ABNORMAL"], optionLabels: ["Normal", "Abnormal"] },
  { label: "Foot Ulceration", values: ["FOOT_ULCERATION_PRESENT", "FOOT_ULCERATION_ABSENT"], optionLabels: ["Present", "Absent"] },
  { label: "Foot Deformity", values: ["FOOT_DEFORMITY_PRESENT", "FOOT_DEFORMITY_ABSENT"], optionLabels: ["Present", "Absent"] },
];

export const ECG_RESULT_OPTIONS = [
  { label: "Sinus Rhythm", value: "SINUS_RHYTHM" },
  { label: "Atrial Fibrillation", value: "ATRIAL_FIBRILLATION" },
  { label: "Pacemaker", value: "PACEMAKER" },
  { label: "Other Abnormal Rhythm", value: "OTHER_ABNORMAL_RHYTHM" },
];

export const ECHO_RESULT_OPTIONS = [
  { label: "(EF <30%) Severely Reduced", value: "SEVERELY_REDUCED" },
  { label: "(EF 30–39%) Moderately Reduced", value: "MODERATELY_REDUCED" },
  { label: "(EF 40–49%) Mildly Reduced", value: "MILDLY_REDUCED" },
  { label: "(EF >50%) Normal", value: "NORMAL" },
  { label: "(EF >70%) Hyperdynamic", value: "HYPERDYNAMIC" },
];

export const SPIROMETRY_RESULT_OPTIONS = [
  { label: "FEV1 ≥80% predicted – Mild (GOLD 1)", value: "MILD_GOLD_1" },
  { label: "50% ≤ FEV1 <80% predicted – Moderate (GOLD 2)", value: "MODERATE_GOLD_2" },
  { label: "30% ≤ FEV1 <50% predicted – Severe (GOLD 3)", value: "SEVERE_GOLD_3" },
  { label: "FEV1 <30% predicted – Very Severe (GOLD 4)", value: "VERY_SEVERE_GOLD_4" },
];

export const VACCINE_OPTIONS = [
  { label: "Yes", value: "YES" },
  { label: "No", value: "NO" },
  { label: "Declined by Patient", value: "DECLINED_BY_PATIENT" },
  { label: "Given Elsewhere", value: "GIVEN_ELSEWHERE" },
];

export const SMOKING_STATUS_OPTIONS = [
  { label: "Current (daily or occasional)", value: "CURRENT" },
  { label: "Ex-smoker (gave up 6 months +)", value: "EX_SMOKER" },
  { label: "Never", value: "NEVER" },
];

export const VAPING_STATUS_OPTIONS = [
  { label: "Current (daily or occasional)", value: "CURRENT" },
  { label: "Ex-user (gave up 6 months +)", value: "EX_USER" },
  { label: "Never", value: "NEVER" },
];

// MECC intervention options. Each option carries a short action `label` plus an
// optional `info` string — the extra detail (URL / helpline / description) shown
// as an under-input hint when the option is selected (see getInterventionInfo).
// Values are BE-enum-locked — do not change them.
export const SMOKING_INTERVENTIONS_OPTIONS = [
  {
    label: "Brief Intervention",
    info: "Emphasising benefits of quitting and offering strategies to help them quit",
    value: "BRIEF_INTERVENTION",
  },
  {
    label: "Signposted to HSE QUIT services",
    info: "Helpline 1800 201 203 and www.quit.ie / www2.hse.ie/mental-and-physical-wellbeing/",
    value: "SIGNPOSTED_TO_HSE_QUIT",
  },
  { label: "Referred to HSE QUIT services", value: "REFERRED_TO_HSE_QUIT" },
  {
    label: "Prescribed or referred for Stop Smoking medication",
    info: "NRT / varenicline",
    value: "PRESCRIBED_MEDICATION",
  },
  {
    label: "Patient Declined / not interested in quitting at this time",
    value: "PATIENT_DECLINED",
  },
  {
    label: "Electronic Referral to HSE QUIT services",
    info: "Healthlink link available",
    value: "ELECTRONIC_REFERRAL_TO_HSE_QUIT",
  },
];

// Returns the `info` hint for the selected option value, or null when the option
// has no extra detail. Generic across every MECC intervention list.
export const getInterventionInfo = (options, value) =>
  options.find((option) => option.value === value)?.info ?? null;

export const ALCOHOL_DEPENDENCE_INTERVENTIONS_OPTIONS = [
  {
    // "(pop up)" is a UI note (opens the full AUDIT tool), not extra detail.
    label: "Complete Full Audit Assessment tool",
    value: "COMPLETE_FULL_AUDIT",
  },
  {
    label: "Signposted to HSE wellbeing services",
    info: "www2.hse.ie/mental-and-physical-wellbeing/",
    value: "SIGNPOSTED_TO_ASKABOUTALCOHOL",
  },
  {
    label: "Referred to specialist substance misuse service",
    value: "REFERRED_TO_SERVICE",
  },
  {
    label: "Patient Declined / not interested in discussion at this time",
    value: "PATIENT_DECLINED",
  },
];

export const ALCOHOL_HIGHER_RISK_INTERVENTIONS_OPTIONS = [
  {
    label: "Complete Full Audit Assessment tool",
    value: "COMPLETE_FULL_AUDIT",
  },
  {
    label: "Signposted to HSE wellbeing services",
    info: "www2.hse.ie/mental-and-physical-wellbeing/",
    value: "SIGNPOSTED_TO_ASKABOUTALCOHOL",
  },
  {
    label: "Referral to HSE Drug and Alcohol confidential helpline",
    info: "Helpline 1800 459 459",
    value: "REFERRAL_TO_HELPLINE",
  },
  {
    label: "Patient Declined / not interested in discussion at this time",
    value: "PATIENT_DECLINED",
  },
];

export const ALCOHOL_INCREASING_RISK_INTERVENTIONS_OPTIONS = [
  {
    label: "Complete Full Audit Assessment tool",
    value: "COMPLETE_FULL_AUDIT",
  },
  {
    label: "Brief Intervention",
    info: "Emphasising benefits of cutting down and exploring strategies to manage drinking pattern",
    value: "BRIEF_INTERVENTION",
  },
  {
    label: "Signposted to HSE wellbeing services",
    info: "www2.hse.ie/mental-and-physical-wellbeing/",
    value: "SIGNPOSTED_TO_ASKABOUTALCOHOL",
  },
  {
    label: "Patient Declined / not interested in discussion at this time",
    value: "PATIENT_DECLINED",
  },
];

export const PHYSICAL_ACTIVITY_Q1_OPTIONS = [
  { label: "0 Days (Inadequate)", value: "ZERO_DAYS" },
  { label: "1-4 days (Inadequate)", value: "ONE_TO_FOUR_DAYS" },
  { label: "5-7 days (Adequate)", value: "FIVE_TO_SEVEN_DAYS" },
  { label: "Unable to be physically active", value: "UNABLE" },
  { label: "No information available", value: "NO_INFO" },
];

export const PHYSICAL_ACTIVITY_Q2_OPTIONS = [
  { label: "Yes (Adequate)", value: "YES_ADEQUATE" },
  { label: "No (Inadequate)", value: "NO_INADEQUATE" },
  { label: "No information", value: "NO_INFO" },
];

export const PHYSICAL_ACTIVITY_INTERVENTIONS_OPTIONS = [
  {
    label: "Given brief advice / brief intervention on benefits of physical activity",
    value: "GIVEN_BRIEF_ADVICE",
  },
  {
    label: "Signposted to HSE wellbeing services",
    info: "www2.hse.ie/mental-and-physical-wellbeing/",
    value: "SIGNPOSTED",
  },
  { label: "Patient declined / not interested", value: "PATIENT_DECLINED" },
];

// NO_ACTION_REQUIRED is only valid for the normal-weight band — the BE enums
// WeightHighRiskIntervention / WeightIncreasedRiskIntervention don't accept it
// (and the MECC spec lists it only under normal weight).
export const WEIGHT_HIGH_RISK_INTERVENTIONS_OPTIONS = [
  { label: "Brief Intervention", value: "BRIEF_INTERVENTION" },
  {
    label: "Signposted to local weight management service",
    info: "www2.hse.ie/mental-and-physical-wellbeing/",
    value: "SIGNPOSTED_TO_SERVICE",
  },
  { label: "Referred to Dietician", value: "REFERRED_TO_DIETICIAN" },
  { label: "Patient declined / not interested", value: "PATIENT_DECLINED" },
];

export const WEIGHT_INCREASED_RISK_INTERVENTIONS_OPTIONS = [
  {
    label: "Given brief advice / brief intervention on benefits of weight reduction",
    value: "GIVEN_BRIEF_ADVICE",
  },
  { label: "Patient declined / not interested", value: "PATIENT_DECLINED" },
];

export const WEIGHT_NORMAL_INTERVENTIONS_OPTIONS = [
  {
    label: "Given brief advice / brief intervention to maintain healthy weight",
    value: "GIVEN_BRIEF_ADVICE",
  },
  {
    label: "Signposted to HSE wellbeing services",
    info: "www2.hse.ie/mental-and-physical-wellbeing/",
    value: "SIGNPOSTED_TO_PROGRAMME",
  },
  { label: "Patient declined / not interested", value: "PATIENT_DECLINED" },
  { label: "No action required", value: "NO_ACTION_REQUIRED" },
];

export const EDUCATION_PROVIDED_OPTIONS = [
  { label: "Yes", value: "YES" },
  { label: "No", value: "NO" },
  { label: "Declined", value: "DECLINED" },
];

export const REFERRED_TO_EDUCATION_OPTIONS = [
  { label: "Yes", value: "YES" },
  { label: "No", value: "NO" },
  { label: "Declined", value: "DECLINED" },
  { label: "Not available", value: "NOT_AVAILABLE" },
];

export const REFERRED_TO_DIABETES_PREVENTION_OPTIONS = [
  { label: "Yes", value: "YES" },
  { label: "No", value: "NO" },
  { label: "Declined", value: "DECLINED" },
  { label: "Not available", value: "NOT_AVAILABLE" },
  { label: "Not required / Not clinically indicated", value: "NOT_CLINICALLY_INDICATED" },
];

export const REFERRAL_DETAILS_OPTIONS = [
  { label: "Referred Previously", value: "REFERRED_PREVIOUSLY" },
  { label: "Referred Today", value: "REFERRED_TODAY" },
  { label: "Declined", value: "DECLINED" },
];

export const AGREED_WRITTEN_CARE_PLAN_OPTIONS = [
  { label: "Yes", value: "YES" },
  { label: "Declined", value: "DECLINED" },
];

// NT-proBNP for OCF & PP is a "hidden button" per the Investigations Matrix:
// the field is wired but hidden until lab capacity is increased. Flip to true
// (and ship the matching backend field — KIN-1050) to surface it.
export const OCF_PP_NT_PROBNP_ENABLED = false;

// Verbatim HSE alert (dataset Ref 63b / OCF Ref 40 / PP) — must display on every
// Treatment, OCF and PP review. Reconciled to the Socrates wording (KIN-1354).
export const NT_PROBNP_ALERT =
  "Indications for NTproBNP testing: In those with new symptoms of possible heart failure it can aid in diagnosis. In established heart failure to help determine if deterioration of symptoms is due to heart failure. In asymptomatic patients at risk for heart failure to identify those most at risk. Repeat testing is not required unless new symptoms.";

// Socrates guidance hint (KIN-1354) — under-input prompt below the Weight field in
// the shared Physical Examination step (CDM / PP / OCF).
export const WEIGHT_MEASUREMENT_HINT =
  "If your scales only go up to 200/220kg, and you don't have a weight from elsewhere recorded for the patient, put in your scales max amount. Put in the higher figure if you have it recorded.";

// Socrates guidance hint (KIN-1354) — under-input prompt below the COVID Vaccine
// field on the CDM and PP Plan & Outcome steps.
export const COVID_VACCINE_ELSEWHERE_PROMPT =
  "Ask your patient: Have you received a Covid vaccine elsewhere since the last date given in the practice?";

// Socrates guidance hint (KIN-1354) — under-input prompt below the Creatinine
// Clearance field on the CDM Tests & Investigations step (A.Fib only, matrix-gated).
export const CREATININE_CLEARANCE_HINT =
  "Original Cockcroft-Gault Formula. Automatically calculated using the patient's age and sex with Serum Creatinine and Weight values.";

// Socrates guidance (KIN-1354) — InfoTooltip on the MECC / interventions ("Risk
// Factors") section header of the CDM and PP Risk & Assessment steps.
export const MECC_INTERVENTION_INFO = [
  "Behaviour change — can be pre-populated from MECC to prompt a discussion regarding a goal.",
  "Use caution: asking closed-ended questions can seem judgmental and cause resistance.",
  "Start by asking the patient what they are already doing to keep themselves healthy, and affirm positive behaviours.",
  "Use normalising statements, e.g. that all of us sometimes do things that aren't good for us.",
  "What behaviours have you been doing that might put you at risk?",
];

// HbA1c out-of-range warning (HL7 Message Spec — dataset Ref 58). A value below
// 28 or above 150 mmol/mol is not blocked on entry: it is submitted as entered
// and the backend records it as 0 in the outgoing message. This warns the user.
export const HBA1C_OUT_OF_RANGE_WARNING =
  "This HbA1c value is outside the valid range (28–150 mmol/mol) and will be recorded as 0.";
